import React from "react";

function ViewBrand({ data, imageUrl }) {
  return (
    <div>
      <div className="main_page">
        <div className="row">
          <div className="col-md-12 text-center mb-4"></div>
          <div className="col-md-12 text-center mb-4"></div>
          <div className="col-md-12 text-center mb-4">
            <img
              src={
                data?.logo
                  ? `${process.env.REACT_APP_IMAGE_URL}/brand/${data.logo}`
                  : "/placeholder-image.png"
              }
              alt={data?.name}
              width="180"
              className="img-thumbnail"
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Vendor</label>
            <input
              type="text"
              className="form-control"
              value={data?.vendor?.name || data?.user?.name || data?.user_id || ""}
              disabled
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Category</label>
            <input
              type="text"
              className="form-control"
              value={data?.category_details?.name }
              disabled
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Sub Category</label>
            <input
              type="text"
              className="form-control"
              value={data?.sub_category?.name }
              disabled
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Child Category</label>
            <input
              type="text"
              className="form-control"
              value={data?.child_category?.name || data?.childCategory?.name || data?.childCategory || data?.child_category_id || ""}
              disabled
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Name</label>
            <input type="text" className="form-control" value={data?.name || ""} disabled />
          </div>

          <div className="col-md-6 mb-3">
            <label>Status</label>
            <input
              type="text"
              className="form-control"
              value={data?.status === 1 || data?.status === true ? "Active" : "Inactive"}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewBrand;